import React from "react";

export default function TruckWiseData() {
  return <div></div>;
}
